import React, { useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'

// component
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'

// helpers
import Axios from '../../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const Register = () => {
  const navigate = useNavigate()
  const { showError, showSuccess } = useToastMessage();

  const [isLoading, setIsLoading] = useState(false)

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      username: '',
      email: '',
      password: ''
    },
    validationSchema: Yup.object().shape({
      first_name: Yup.string().required("Please enter your first name."),
      last_name: Yup.string().required("Please enter your last name."),
      username: Yup.string().required("Please enter your username."),
      email: Yup.string().required("Please enter your email address."),
      password: Yup.string().required("Please enter your password.")
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  const handleInputValue = (values) => {
    const payload = {}

    payload.profile = {
      first_name: values.first_name,
      last_name: values.last_name
    }
    payload.username = values.username
    payload.email = values.email
    payload.password = values.password

    return payload
  }

  const handlePost = (payload) => {
    setIsLoading(true)
    Axios({
      method: "post",
      url: '/api/sso/v1/admin/create',
      data: payload
    })
      .then(({ data }) => {
        if (data) {
          showSuccess('You have successfully registered, please check your mailbox to validate your account')
          setTimeout(() => {
            navigate('/login')
          }, 2500)
        }
      })
      .catch((err) => {
        const errMsg = err?.response?.data?.message
        if (errMsg == 'user-not-verified') {
          showError('Your account is already. Please verify your email!')
        }
        if (errMsg == 'user-not-active') {
          showError('Your account is waiting for approval')
        }
      })
      .finally(() => setIsLoading(false))
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={9} lg={7} xl={6}>
            <CCard className="mx-4">
              <CCardBody className="p-4">
                <h1>Register</h1>
                <p className="text-medium-emphasis">Create your account</p>
                <CInputGroup className="mb-3">
                  <CInputGroupText>
                    <CIcon icon={cilUser} />
                  </CInputGroupText>
                  <CFormInput
                    id='first_name'
                    name='first_name'
                    placeholder="First Name"
                    value={formik.values.first_name}
                    onChange={(e) => formik.handleChange(e)}
                    invalid={formik.errors.first_name}
                    feedbackInvalid={formik.errors.first_name}
                    autoComplete='off'
                  />
                </CInputGroup>
                <CInputGroup className="mb-3">
                  <CInputGroupText>
                    <CIcon icon={cilUser} />
                  </CInputGroupText>
                  <CFormInput
                    id='last_name'
                    name='last_name'
                    placeholder="Last Name"
                    value={formik.values.last_name}
                    onChange={(e) => formik.handleChange(e)}
                    invalid={formik.errors.last_name}
                    feedbackInvalid={formik.errors.last_name}
                    autoComplete='off'
                  />
                </CInputGroup>
                <CInputGroup className="mb-3">
                  <CInputGroupText>
                    <CIcon icon={cilUser} />
                  </CInputGroupText>
                  <CFormInput
                    id='username'
                    name='username'
                    placeholder="Username"
                    value={formik.values.username}
                    onChange={(e) => formik.handleChange(e)}
                    invalid={formik.errors.username}
                    feedbackInvalid={formik.errors.username}
                    autoComplete='off'
                  />
                </CInputGroup>
                <CInputGroup className="mb-3">
                  <CInputGroupText>@</CInputGroupText>
                  <CFormInput
                    type='email'
                    id='email'
                    name='email'
                    placeholder="Email Address"
                    value={formik.values.email}
                    onChange={(e) => formik.handleChange(e)}
                    invalid={formik.errors.email}
                    feedbackInvalid={formik.errors.email}
                    autoComplete='off'
                  />
                </CInputGroup>
                <CInputGroup className="mb-3">
                  <CInputGroupText>
                    <CIcon icon={cilLockLocked} />
                  </CInputGroupText>
                  <CFormInput
                    type="password"
                    placeholder="Password"
                    id='password'
                    name='password'
                    value={formik.values.password}
                    onChange={(e) => formik.handleChange(e)}
                    invalid={formik.errors.password}
                    feedbackInvalid={formik.errors.password}
                    autoComplete='off'
                  />
                </CInputGroup>
                <div className="d-grid gap-2 d-md-flex">
                  <CButton
                    color="dark"
                    onClick={() => formik.handleSubmit()}
                  >
                    {isLoading && (
                      <CSpinner
                        className='me-2'
                        component="span"
                        color="light"
                        size="sm"
                        aria-hidden="true"
                      />
                    )}
                    Create Account
                  </CButton>
                  <CButton
                    color="dark"
                    onClick={() => navigate('/login')}
                  >
                    Login
                  </CButton>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Register
